<style>
.ivu-breadcrumb a {
  font-size: 12px;
  color: #8f8f8f !important;
}
.ivu-breadcrumb a:hover {
  color: #ccc !important;
}
</style>
<template>
  <div>
    <Breadcrumb
      separator=">"
      v-if="searchRouterArray.length"
      class="m-b-10"
    >
      <BreadcrumbItem
        v-for="(item,index) in searchRouterArray"
        :key="'router_'+index"
        :to="item.path"
      >{{item.title}}</BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>

<script>
export default {
  computed: {
    searchRouterArray () {
      let result = JSON.parse(sessionStorage.getItem('searchRouters')) || []
      return result.sort(function (a, b) {
        return a.sort - b.sort
      })
    }
  }
}
</script>
